import React from "react";
import { motion } from "framer-motion";

/**
 * PageWrapper – fade+slide transition wrapper used per route to give
 * smooth page transitions.
 */
const PageWrapper = ({ children, testId }) => (
  <motion.main
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -12 }}
    transition={{ duration: 0.4, ease: "easeOut" }}
    data-testid={testId || "page-wrapper"}
  >
    {children}
  </motion.main>
);

export default PageWrapper;
